
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { BModal } from "bootstrap-vue";
import { IUserClientData, IUserDetail } from "@/entities";
import { VueComponent } from "@/vue-ts-component";
import PModal from "@/components/look/PModal.vue";
import { ValidationObserver } from "vee-validate";
import Multiselect from "vue-multiselect";
import { IEmployeeSearchReportRequest, IInformationOptionsEmployees } from "@/services";
import { Action, Getter } from "vuex-class";
import { SweetAlertResult } from "sweetalert2";
import { Locale } from "@/store";

@Component({
  name: "firms-report-employee-search-modal",
  components: { PModal, ValidationObserver, Multiselect },
})
export default class FirmsReportEmployeeSearchModal extends Vue {
  @Prop({ required: true, default: [] })
  clients: IUserClientData[] | undefined;
  @Prop({ required: true, default: undefined })
  informationOptionsEmployees: IInformationOptionsEmployees | undefined;

  @Getter("getLocale") locale!: Locale;
  @Getter("getLoggedUser") loggedUser!: IUserDetail;

  @Action("generateEmployeeSearchReport") generateEmployeeSearchReport!: (
    request: IEmployeeSearchReportRequest
  ) => Promise<void>;

  public clientSelected?: IUserClientData;
  public dateFrom: Date = new Date();
  public dateTo: Date = new Date();
  entities: string[] = [];

  @Watch("dateFrom")
  onDateFromChange(newDateFrom: Date): void {
    if (newDateFrom && newDateFrom > this.dateTo) {
      this.dateFrom = this.dateTo;
    }
  }

  @Watch("dateTo")
  onDateToChange(newDateTo: Date): void {
    if (newDateTo && newDateTo < this.dateFrom) {
      this.dateTo = this.dateFrom;
    }
  }

  get minDate(): Date {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 90);
    return minDate;
  }

  async mounted(): Promise<void> {
    this.$on("showFirmsReportEmployeeSearchModal", () => {
      this.showModal();
    });
  }

  async showModal(): Promise<void> {
    const pModal = this.$refs.firmsReportEmployeeSearchModal as VueComponent<any>;
    const bModal = pModal.$children[0] as BModal;
    bModal.show();
  }

  async onSubmit(): Promise<void> {
    const { isConfirmed } = await this.modalConfirm();
    if (isConfirmed) {
      await this.generateEmployeeSearchReport(this.employeeSearchReportParams);
      this.makeToast("success", this.$t("message.usersreport.ok").toString());
      this.$emit("success");
      this.hideModal();
    }
  }

  hideModal(): void {
    const pModal = this.$refs.firmsReportEmployeeSearchModal as PModal;
    const bModal = pModal.$children[0] as BModal;
    bModal.hide();
  }

  makeToast(variant: string, message: string): void {
    this.$bvToast.toast(message, {
      autoHideDelay: 4000,
      variant,
      toaster: "b-toaster-bottom-center",
      noCloseButton: true,
    });
  }

  get maxDate(): Date {
    return new Date();
  }

  private get employeeSearchReportParams(): IEmployeeSearchReportRequest {
    const clientId =
      this.clients && this.clients?.length > 1 ? this.clientSelected?.id : this.clients?.[0]?.id;

    return {
      employeeSearchReportFilterDTO: {
        clientId,
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
      },
      informationOptionsEmployees: this.informationOptionsEmployees,
    } as IEmployeeSearchReportRequest;
  }

  initData(): void {
    this.clientSelected = this.clientSelected = this.clients?.[0];
    this.dateTo = new Date();
    this.dateTo.setHours(0, 0, 0, 0);
    this.dateFrom = new Date(this.dateTo);
    this.dateFrom.setDate(this.dateFrom.getDate() - 90);
    this.dateFrom.setHours(0, 0, 0, 0);
  }

  async modalConfirm(): Promise<SweetAlertResult> {
    return this.$swal({
      title: this.$t("label.confirmation.to.export.message").toString(),
      text: this.$t("label.confirmation.to.export.message.description").toString(),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: this.$t("label.yes").toString(),
      cancelButtonText: this.$t("label.no").toString(),
    });
  }
}
